export default "__VITE_ASSET__G0$DMVWY__"